import React from "react";
import Page from "../components/layout/Page";

type InlineNode = string | React.ReactElement;

const privacyPolicyContent = String.raw`
**1           Introducere**

Vă mulțumim pentru interesul față de societatea noastră pentru produsele și/sau serviciile  noastre.
Protecția și confidențialiatea datelor cu caracter personal este un subiect foarte important pentru noi. Când intrați într-o relație de orice fel cu noi, ne încredințați informațiile dumneavoastră. Aceste informații prezentate în prezentul document (denumit în continuare *„Politică de confidențialitate”* sau *„Documentul”*) sunt importante.
**Vă recomandăm să le citiți cu atenție.** Scopul acestei Politici de confidențialitate este vă explice ce date prelucrăm (colectăm, utilizăm, partajăm), de ce le prelucrăm, în ce modalitate le prelucrăm, drepturile dvs. în temeiul GDPR și modalitatea în care vă puteți exercita aceste drepturi. În colectarea acestor informații, noi acționăm în calitate de Operator și, prin lege, suntem obligați să vă furnizăm aceste informații.

Fiind pe deplin conștienți de faptul că informațiile personale vă aparțin, facem tot posibilul să le stocăm în siguranță și să le prelucrăm cu atenție. Nu oferim informații unor părți terțe fără a vă informa în conformitate cu prevederile legale. Nu luăm decizii exclusiv automate cu impact semnificativ asupra dvs.

Prin vizitarea site-ului nostru [www.asempera.ro](http://www.asempera.ro), achiziționarea produselor noastre sau prin interacțiunea cu noi prin orice mijloc și/sau prin intermediul oricărui canal de comunicare (e-mail, telefon, rețele de socializare etc), sunteți de acord cu această Politică de confidențialitate. Dacă nu sunteți de acord cu cele descrise în prezenta Politică de Confidențialitate, vă rugăm să nu utilizați serviciile **Societății ASEMPERA S.R.L.,** fiind operator de date în sensul Regulamentului General Privind Protectia Datelor cu Caracter Personal (GDPR).

**2           DEFINIȚII**

1.1. „GDPR”, „RGPD” sau „Regulamentul” înseamnă REGULAMENTUL (UE) 2016/679 AL PARLAMENTULUI EUROPEAN ȘI AL CONSILIULUI din 27 aprilie 2016 privind protecția persoanelor fizice în ceea ce privește prelucrarea datelor cu caracter personal și privind libera circulație a acestor date și de abrogare a Directivei 95/46/CE (Regulamentul general privind protecția datelor).

1.2. *„Operatorul”* sau *„Noi”* înseamnă Societatea ASEMPERA S.R.L., cu sediul social situat în Str. Tabacarilor nr. 2 Localitatea Cluj Napoca Jud. Cluj, înmatriculată la Oficiul Registrului Comerțului sub nr. J2015002010128 având Cod Unic de Identificare - 34729935.

1.3. *„Persoană vizată”* reprezintă orice persoană fizică identificată sau identificabilă ale cărei date sunt prelucrate de către noi în calitate de operator, ca de exemplu clienți, potențiali clienți sau vizitatori ai site-ului.

1.4. *„Prelucrare”* înseamnă orice operațiune sau set de operațiuni efectuate asupra datelor cu caracter personal sau asupra seturilor de date cu caracter personal, cu sau fără utilizarea de mijloace automatizate, cum ar fi colectarea, înregistrarea, organizarea, structurarea, stocarea, adaptarea sau modificarea, extragerea, consultarea, utilizarea, divulgarea prin transmitere, diseminarea sau punerea la dispoziție în orice alt mod, alinierea sau combinarea, restricționarea, ștergerea sau distrugerea.

1.5. *„Consimțământ”* înseamnă orice manifestare de voință liberă, specifică, informată și lipsită de ambiguitate a persoanei vizate prin care aceasta acceptă, printr-o declarație sau printr-o acțiune fără echivoc, ca datele cu caracter personal care o privesc să fie prelucrate de Operator.

1.6. *„Date cu caracter personal”* înseamnă orice informații privind o persoană fizică identificată sau identificabilă („persoana vizată”); o persoană fizică identificabilă este o persoană care poate fi identificată, direct sau indirect, în special prin referire la un element de identificare, cum ar fi un nume, un număr de identificare, date de localizare, un identificator online, sau la unul sau mai multe elemente specifice, proprii identității sale fizice, fiziologice, genetice, psihice, economice, culturale sau sociale.

Ceilalți termeni utilizați în prezentul document au înțelesul conferit de GDPR și celelalte prevederi legale aplicabile.

**3           ALTE SERVICII**

Această Politică de confidențialitate nu acoperă aplicațiile și site-urile altor terți la care puteți ajunge prin accesarea link-urilor de pe site-ul nostru. Acest lucru excedează controlului nostru. Vă încurajăm să examinați Politica de confidențialitate de pe orice site și/sau aplicație înainte de a furniza date personale.

**4           CINE SUNTEM NOI?**

Societatea ASEMPERA S.R.L., cu sediul social situat în Str. Tabacarilor nr. 2 Localitatea Cluj Napoca Jud. Cluj, înmatriculată la Oficiul Registrului Comerțului sub nr. J2015002010128 având Cod Unic de Identificare - 34729935 este responsabilă de prelucrarea datelor dvs. cu caracter personal pe care le colectăm direct de la dvs. sau din alte surse.

Potrivit legislației, societatea noastră este operator de date cu caracter personal. Pentru ca datele dvs. să fie prelucrate în siguranță, am depus toate eforturile să implementăm măsuri rezonabile și adecvate, tehnice și organizatorice pentru a proteja datele dvs. cu caracter personal.

**5           Cine sunteți dvs.?**

Potrivit legislației, dvs., persoana fizică beneficiară a serviciilor/produselor noastre, reprezentantul ori persoana de contact a unei companii care ne este client sau potential client, vizitatorul site-ului sau persoana aflată într-o relație de orice fel cu noi, sunteți o „persoană vizată”, adică o persoană fizică identificată sau identificabilă. Pentru a fi complet transparenți în privința prelucrării de date și pentru a vă permite să vă exercitați cu ușurință, în orice moment, drepturile, am implementat măsuri pentru a facilita exercitarea drepturilor.

**6           ANGAJAMENTUL NOSTRU**

Protecția informațiilor dvs. personale este foarte importantă pentru noi. De aceea, ne-am luat angajamentul să respectăm legislația europeană și națională privind protecția datelor cu caracter personal, în special Regulamentul (EU) 679/2016, cunoscut și sub denumirea de GDPR și următoarele principii:

* Legalitate, echitate și transparență
* Controlul vă aparține
* Integritatea datelor și limitarea scopului
* Securitate

Prelucrăm datele dvs. legal și corect. Suntem întotdeauna transparenți în privința informațiilor pe care utilizăm, iar dvs. sunteți informat corespunzător.

În limitele legii, vă oferim posibilitatea de examina, modifica, șterge datele personale pe care le-ați împărtășit cu noi și de a vă exercita celelalte drepturi.

Utilizăm datele numai în scopurile descrise la momentul colectării sau în noi scopuri compatibile cu cele inițiale. În toate cazurile, scopurile noastre sunt compatibile cu legislația. Luăm măsuri rezonabile pentru a ne asigura că datele personale sunt corecte, complete și actualizate.

Am implementat măsuri rezonabile de securitatea prelucării datelor cu caracter personal, astfel încât să vă protejăm cât mai bine informațiile personale. Cu toate acestea, rețineți faptul că niciun site web, nicio aplicație și nicio conexiune la internet nu este complet sigură.

**7           SCHIMBĂRI**

Putem schimba această Politică de confidențialitate în orice moment. Toate actualizările și modificările prezentei Politici sunt valabile imediat, de aceea va rugăm sa citiți mereu această Politică de confidențialitate.

**8           INFORMAȚIILE DVS. SCOPURI. TEMEIURI LEGALE.**

Atunci când navigați pe site-ul nostru, când ne transmiteți o solicitare pe e-mail sau ne contactați în orice alt scop și pe orice alt canal de comunicare, ne puteți comunica următoarele date personale, pe care le colectăm direct de la dvs. sau din alte surse, așa cum explicăm în tabelul de mai jos.

| Datele cu caracter personal prelucrate | Scop/Scopuri | Temei/Temeiuri Legale |
| :--- | :--- | :--- |
| **Nume Adresă** | În scopul creării unui cont pe site. Pentru facturare. Pentru a ne conforma legislației. Pentru prevenirea fraudelor și a altor infracțiuni. Pentru marketing direct, doar dacă avem consimțământul dvs. prealabil. | Încheierea sau executarea unui contract - **Art. 6 (1) b GDPR**. Obligația legală - **Art. 6 (1) c GDPR**. Consimțământ - **Art. 6 (1) a**, doar pentru marketing direct. |
| **E-mail** | În scopul creării unui cont pe site. Pentru facturare. Pentru a ne conforma legislației. Pentru prevenirea fraudelor și a altor infracțiuni. Pentru marketing direct, doar dacă avem consimțământul dvs. prealabil. | Încheierea sau executarea unui contract - **Art. 6 (1) b GDPR**. Consimțământ - **Art. 6 (1) a**, doar pentru marketing direct. Interes legitim - **Art. 6 (1) f GDPR**. |
| **Adresă IP** | Pentru a ne proteja împotriva atacurilor cibernetice. Pentru prevenirea fraudelor și a altor infracțiuni. Pentru funcționarea rețelei. | Interes legitim - **Art. 6 (1) f GDPR**. |

Cele mai multe informații le colectăm direct de la dvs. (de exemplu, prin completarea unui formular de pe site). Majoritatea informațiile sunt cele descrise mai sus, dar pot exista situații în care colectăm date de la terți (i.e. parteneri, platforme).

Pe lângă informațiile indicate mai sus, este posibil să colectăm și următoarele informații, în funcție de circumstanțe:

* Modul în care interacționați cu site-ul/site-urile nostru/noastre (de exemplu, informații despre cum și când ne accesați site-ul sau ce dispozitiv folosiți pentru a accesa site-ul). Pentru mai multe informații în acest sens, vă invităm să lecturați și Politica noastră privind utilizarea modulelor de cookie-uri.
* Conținutul mesajelor trimise prin sisteme de mesagerie și e-mail.

Pe lângă scopurile enumerate în tabelul din secțiunea anterioară, prelucrăm datele cu caracter personal și în următoarele scopuri:

* Pentru a vă răspunde la întrebări și solicitări și a vă furniza serviciul de asistență clienți;
* În scop de marketing, însă doar în situația în care avem consimțământul dvs. prealabil sau când există o excepție legală de la obținerea consimțământului;
* Pentru a oferi și îmbunătăți serviciile pe care le oferim;
* Pentru a diagnostica sau a remedia probleme tehnice;
* Pentru a ne apăra împotriva atacurilor cibernetice;
* Pentru a ne conforma legislației, ca de exemplu conformarea cu legislația fiscală care ne obligă să păstrăm documentele contabile pe o perioadă de 10 ani;
* În situația puțin probabilă a unui litigiu, pentru constatarea sau revendicarea unui drept în instanță.

**8.1         ALTE INFORMAȚII DESPRE TEMEIURI LEGALE**

**(a) Interes legitim.** În situația în care utilizăm interesul legitim, efectuăm o analiză a interesului legitim (test de echilibrare) prin intermediul căreia putem în balanță interesul nostru și interesele dvs. În situația în care prevalează interesele noastre, vom utiliza interesul legitim. În situația în care prevalează interesele dvs., nu vom utiliza interesul legitim, iar în măsura în care nu reușim să identificăm un alt temei legal corect, nu vom efectua respectiva activitate de prelucrare.

**(b) Consimțământ.** Rețineți faptul că obținerea consimțământului nu este obligatorie, iar noi vom proceda la obținerea consimțământului din partea dvs. doar în situațiile în care nu reușit să utilizăm un alt temei legal. În prezent utilizăm consimțământul doar pentru e-mail marketing.

**(c) Interes vital.** În situația puțin probabilă a unei urgențe medicale sau a unui alt eveniment exceptional prelucrarea poate fi necesară pentru a proteja interesele vitale ale dvs. sau ale altei persoane fizice.

**9           PERIOADA DE STOCARE**

Stocăm datele dvs. cu caracter personal doar pe perioada necesară îndeplinirii scopurilor, dar nu mai mult de 5 ani de la încetarea contractului sau ultima interacțiune cu noi.

După încetarea perioadei, datele cu caracter personal vor fi distruse sau șterse din sistemele informatice sau transformate în date anonime pentru a fi utilizate în scopuri de cercetare științifică, istorică sau statistică.

Rețineți faptul că în anumite situații expres reglementate, stocăm datele pe perioada care ne este impusă de lege.

**10       TRANSFERURI DE DATE**

Putem dezvălui datele dvs., respectând legea aplicabilă, partenerilor de afaceri sau altor terți. Depunem în permanență eforturi rezonabile pentru a ne asigura că acești terți au implementate măsuri adecvate de protecție și securitate. Cu acești terți avem clauze contractuale astfel încât datele dvs. să fie protejate. În aceste situații, ne vom asigura că orice transfer este legitim conform legislației.

Putem transmite datele și altor părți având consimțământul sau potrivit instrucțiunilor dvs, ca de exemplu, în situația în care exercitați o cerere de portabilitate.

Vom putea, de asemenea, furniza informațiile dvs. cu caracter personal și către parchet, poliție, instanțele judecătorești și alte organe abilitate ale statului, în baza și în limitele prevederilor legale și ca urmare a unor cereri expres formulate.

Transferul de date cu caracter personal către un stat terț poate avea loc numai dacă statul către care se intenționează transferul asigură un nivel de protecție adecvat.

Transferul de date către un stat a cărui legislație nu prevede un nivel de protecție cel puțin egal cu cel oferit de Regulament General de Protecție a Datelor este posibil numai dacă există garanții suficiente cu privire la protecția drepturilor fundamentale ale persoanelor vizate. Aceste garanții vor fi stabilite de noi prin contracte încheiate cu furnizorii/prestatori de servicii către care se va realiza transferul datelor tale personale.

De fiecare dată când vom transfera datele tale personale în afara SEE, ne vom asigura că există un nivel de protecția similar prin unul din următoarele mecanisme de salvgardare:

* Vom transfera datele tale personale către țări unde s-a demonstrat de către Comisia Europeană că furnizează un nivel adecvat de siguranță pentru datele personale.
* Când apelăm la anumiți furnizori de servicii, vom putea folosi anumite modele de contracte furnizate și aprobate de Comisia Europeană care oferă datelor personale aceeași protecție pe care o au în Europa.

**11       SECURITATEA DATELOR**

Înțelegem cât de importantă este securitatea datelor personale și luăm măsurile necesare pentru a proteja clienții noștri și alte persoane ale căror date le prelucrăm de accesul neautorizat al datelor personale, precum și de modificarea, divulgarea sau distrugerea neautorizata ale datelor pe care le prelucrăm în activitatea curentă.

Am implementat următoarele măsuri tehnice și organizatorice de securitate a datelor cu caracter personal:

**a) Politici dedicate.** Adoptăm și revizuim constant practicile și politicile interne de prelucrare a datelor personale (inclusiv măsurile fizice și electronice de securitate), pentru a ne proteja sistemele de un eventual acces neautorizat sau alte posibile amenințări la securitatea acestora. Aceste politici sunt supuse unor verificări constante, pentru a ne asigura că respectăm cerințele legale și că sistemele funcționează în mod adecvat.

**b) Minimizarea datelor.** Ne asigurăm că datele tale cu caracter personal pe care le prelucrăm sunt limitate doar la cele necesare, adecvate și relevante pentru scopurile declarate în această Politică.

**c) Restrângerea accesului la date.** Încercăm să restrângem cât mai mult accesul la datele cu caracter personal pe care le prelucrăm la minimul necesar: angajați, colaboratori și alte persoane care au nevoie să acceseze aceste date pentru a le prelucra și a duce la îndeplinire un serviciu. Partenerii și colaboratorii noștri sunt supuși unor obligații stricte de confidențialitate (fie prin contract, fie legale).

**d) Măsuri tehnice specifice.** Utilizăm tehnologii care să asigure securitatea clienților noștri, încercând întotdeauna să implementăm cele mai optime soluții pentru protecția datelor. De asemenea, facem back-up-uri periodice de date pentru a le putea recupera în cazul unui eventual incident și avem implementate proceduri de audit periodice în privința securității echipamentelor folosite. Totuși, niciun site web, nicio aplicație și nicio conexiune la internet nu este complet sigură și de neatins.

**e) Asigurarea exactității datelor tale.** Câteodată este posibil să îți cerem să confirmi exactitatea sau actualitatea datelor tale pentru a fi siguri că ele reflectă realitatea.

**f) Instruirea personalului.** Ne instruim și testăm constant angajații și colaboratorii cu privire la legislația și cele mai bune practici în domeniul prelucrării datelor cu caracter personal.

**g) Anonimizarea datelor.** Acolo unde putem, încercăm pe cât posibil să anonimizăm/pseudoanonimizăm datele cu caracter personal pe care le prelucrăm, astfel încât să nu mai putem identifica persoanele la care acestea se referă.

Cu toate acestea, deși depunem eforturi constante pentru a asigura securitatea datelor pe care ni le încredințezi, este posibil să avem parte și de evenimente mai puțin fericite și să avem incidente/breșe de securitate. În aceste cazuri, vom urma cu strictețe procedura de raportare și notificare a incidentelor de securitate și vom lua toate măsurile necesare pentru a readuce situația la normal în cel mai scurt timp posibil.

**12       MARKETING DIRECT**

În măsura în care am obținut consimțământul dvs. prealabil sau sunteți deja un client al companiei, putem utiliza tehnologii de marketing direct utilizând informațiile colectate despre dvs. În prezent transmitem mesaje comerciale pe e-mail (e-mail marketing) către persoanele care și-au exprimat consimțământul în acest sens în prealabil.

**13       DREPTURILE DVS.**

Drepturile dvs. conform Regulamentului GDPR sunt următoarele:

**(a) Dreptul de a fi informat cu privire la prelucrarea datelor dvs.**

**(b) Dreptul de acces asupra datelor.** Aveți dreptul de a obține din partea noastră o confirmare că se prelucrează sau nu date cu caracter personal care vă privesc și, în caz afirmativ, acces la datele respective și la informațiile prevăzute de art. 15 alin. (1) din GDPR;

**(c) Dreptul de a rectifica datele inexacte sau incomplete.** Aveți dreptul de a obține, din partea noastră, fără întârzieri nejustificate, rectificarea datelor cu caracter personal inexacte care vă privesc;

**(d) Dreptul la ștergere („dreptul de a fi uitat”).** În situațiile prevăzute la art. 17 din GDPR, aveți dreptul de a solicita și obține ștergerea datelor cu caracter personal;

**(e) Dreptul la restricționarea prelucrării.** În cazurile prevăzute la art. 18 din GDPR, aveți dreptul de a solicita și obține restricționarea prelucrării;

**(f) Dreptul de a transmite datele pe care le avem despre dvs. către alt operator („dreptul la portabilitate”).** Dreptul de a transmite datele pe care le avem despre dvs. către alt operator („dreptul la portabilitate”);

**(g) Dreptul de a vă opune prelucrării datelor.** În cazurile prevăzute la art. 21 din GDPR, aveți dreptul de a vă opune prelucării datelor;

**(h) Dreptul de a nu face obiectul unei decizii bazate exclusiv pe prelucrarea automată, inclusiv crearea de profiluri cu efecte juridice sau cu efecte semnificative similare asupra asupra dvs.;**

**(i) Dreptul de a vă adresa justiției pentru apărarea drepturilor și intereselor dvs.;**

**(j) Dreptul de a face o plângere în fața unei Autorități de Supraveghere.**

| Nume | Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal |
| :--- | :--- |
| **Adresa** | B-dul G-ral. Gheorghe Magheru nr. 28-30, Sector 1, cod poștal 010336, București, România |
| **Telefon** | +40.318.059.211 sau +40.318.059.212 |
| **E-mail** | [anspdcp@dataprotection.ro](mailto:anspdcp@dataprotection.ro) |

**Vă rugăm să rețineți că:**

(1) Vă puteți retrage consimțământul pentru marketing direct în orice moment prin urmarea instrucțiunilor de dezabonare din fiecare e-mail.

(2) Drepturile enumerate mai sus nu sunt absolute. Există excepții, de aceea fiecare cerere primită va fi analizată astfel încât să decidem dacă este întemeiată sau nu. În măsura în care cererea este întemeiată, vă vom facilita exercitarea drepturilor. Dacă cererea este neîntemeiată, o vom respinge, însă vă vom informa asupra motivelor refuzului și asupra drepturilor de a depune o plângere la Autoritatea de Supraveghere și de a vă adresa justiției.

(3) Vom încerca să răspundem solicitării în termen de o lună. Cu toate acestea, termenul poate fi prelungit în funcție de diferite aspect, precum complexitatea cererii, numărul mare de cereri primite sau imposibilitatea de a vă identifica într-un termen util.

(4) Dacă, deși depunem toate eforturile, nu reușim să vă identificăm, iar dvs. nu ne furnizați informații suplimentare pentru a reuși să vă identificăm, nu suntem obligați să dăm curs solicitării.

**14     ÎNTREBĂRI, SOLICITĂRI ȘI EXERCITAREA DREPTURILOR**

Dacă aveți întrebări sau nelămuriri cu privire la prelucrarea informațiilor dvs sau doriți să vă exercitați drepturile legale sau aveți orice altă îngrijorare cu privire la confidențialitatea datelor pe care le puneți la dispoziția noastră, ne puteți contacta la adresa societății sau la adresa de e-mail: info@asempera.ro.
`;

function renderInline(text: string): InlineNode[] {
  const nodes: InlineNode[] = [];
  const pattern = /(\*\*([^*]+)\*\*)|(\*([^*]+)\*)|(\[([^\]]+)\]\(([^)]+)\))/g;
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = pattern.exec(text))) {
    if (match.index > lastIndex) {
      nodes.push(text.slice(lastIndex, match.index));
    }

    if (match[2]) {
      nodes.push(<strong key={`${match.index}-strong`}>{match[2]}</strong>);
    } else if (match[4]) {
      nodes.push(<em key={`${match.index}-em`}>{match[4]}</em>);
    } else if (match[6] && match[7]) {
      nodes.push(
        <a key={`${match.index}-link`} href={match[7]}>
          {match[6]}
        </a>,
      );
    }

    lastIndex = pattern.lastIndex;
  }

  if (lastIndex < text.length) {
    nodes.push(text.slice(lastIndex));
  }

  return nodes;
}

function isHeading(line: string) {
  return /^\*\*\d+/.test(line) || /^\*\*\d+\.\d+/.test(line);
}

function renderTable(lines: string[], startIndex: number) {
  const tableLines: string[] = [];
  let index = startIndex;

  while (index < lines.length && lines[index].trim().startsWith("|")) {
    tableLines.push(lines[index]);
    index += 1;
  }

  const rows = tableLines
    .filter((line) => !/^\|\s*:?-+:?\s*\|/.test(line))
    .map((line) =>
      line
        .trim()
        .replace(/^\||\|$/g, "")
        .split("|")
        .map((cell) => cell.trim()),
    );

  return {
    nextIndex: index,
    element: (
      <div className="legal-table-wrapper" key={`table-${startIndex}`}>
        <table>
          <thead>
            <tr>
              {rows[0].map((cell, cellIndex) => (
                <th key={cellIndex}>{renderInline(cell)}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.slice(1).map((row, rowIndex) => (
              <tr key={rowIndex}>
                {row.map((cell, cellIndex) => (
                  <td key={cellIndex}>{renderInline(cell)}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ),
  };
}

function renderMarkdown(markdown: string) {
  const lines = markdown.trim().split("\n");
  const elements: React.ReactElement[] = [];
  let index = 0;

  while (index < lines.length) {
    const line = lines[index].trim();

    if (!line) {
      index += 1;
      continue;
    }

    if (line.startsWith("|")) {
      const table = renderTable(lines, index);
      elements.push(table.element);
      index = table.nextIndex;
      continue;
    }

    if (isHeading(line)) {
      elements.push(
        <h2 key={`heading-${index}`}>
          {renderInline(line.replace(/^\*\*|\*\*$/g, "").replace(/\s+/g, " "))}
        </h2>,
      );
      index += 1;
      continue;
    }

    if (line.startsWith("* ")) {
      const items: string[] = [];
      while (index < lines.length && lines[index].trim().startsWith("* ")) {
        items.push(lines[index].trim().slice(2));
        index += 1;
      }
      elements.push(
        <ul key={`list-${index}`}>
          {items.map((item, itemIndex) => (
            <li key={itemIndex}>{renderInline(item)}</li>
          ))}
        </ul>,
      );
      continue;
    }

    elements.push(<p key={`paragraph-${index}`}>{renderInline(line)}</p>);
    index += 1;
  }

  return elements;
}

export default function Confidentialitate() {
  return (
    <Page>
      <div className="page-title">
        <h1>Politică de confidențialitate</h1>
      </div>
      <div className="an-section">
        <div className="an-content">
          <article className="legal-content">
            {renderMarkdown(privacyPolicyContent)}
          </article>
        </div>
      </div>
    </Page>
  );
}
